import { Box } from '@mui/material'
import { ReactComponent as NextIcon } from 'assets/arrow_back_logo.svg'
import { ICameraListItem } from 'models/IFrameInfo'
import React from 'react'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

type Step1Props = {
	cameraList: ICameraListItem[]
	setStep: (step: number) => void
	setCameraInfo: (el: ICameraListItem) => void
}

export const SelectDigitization = (props: Step1Props) => {
	const { cameraList, setStep, setCameraInfo } = props
	const sortedCameraList = cameraList?.slice().sort((a, b) => {
		if (a.milking_hall < b.milking_hall) return -1
		if (a.milking_hall > b.milking_hall) return 1
		return 0
	})
	let lastMilkingHall = ''
	return (
		<Box
			marginBottom={'12px'}
			padding={'0px 24px 14px 24px'}
			sx={{
				maxHeight: '400px',
				'&::-webkit-scrollbar': {
					width: 4,
					height: 4,
				},
				'&::-webkit-scrollbar-track': {
					backgroundColor: '#DBDBDB',
					borderRadius: 12,
				},
				'&::-webkit-scrollbar-thumb': {
					backgroundColor: COLORS.icon,
					borderRadius: 12,
				},
				overflow: 'auto',
				display: 'flex',
				flexDirection: 'column',
				gap: '16px',
			}}
		>
			{sortedCameraList?.map(el => {
				const shouldRenderMilkingHall = el.milking_hall !== lastMilkingHall
				lastMilkingHall = el.milking_hall

				return (
					<React.Fragment key={el.key}>
						{shouldRenderMilkingHall && (
							<TypographySecondary14>{el.milking_hall}</TypographySecondary14>
						)}
						<CardStandart
							onClick={() => {
								setCameraInfo(el)
								setStep(2)
							}}
							sx={{
								border: `1px solid ${COLORS.inputBorder}`,
								padding: '24px',
								cursor: 'pointer',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}
						>
							<TypographyPrimary16Bold>{el.title}</TypographyPrimary16Bold>
							<NextIcon style={{ transform: 'rotate(180deg)' }} />
						</CardStandart>
					</React.Fragment>
				)
			})}
		</Box>
	)
}
